const StorRequiredFields = {
    identitaSegnalante: {
        persFisicaSegnalante: ["nome","cognome","posPrezzoSegnalante","numTelefono1"],
        datiAnagraficiSegnalante : ["nomeSoggettoSegnalante","tipoSoggettoSegnalante","codiceLEI","via","codPostale","nazione","regione","provincia",],
        vesteSegnalante : ["vesteSegnalante","catTipologiaNegoziazione","catTipologiaStrumNegoziato","relazioneConSoggSegnalato"],
        referenteRichiestaMaggioriInfo : ["nomeReferente","cognomeReferente","indirizzoMailReferente","posizioneReferente","numCellulare","numTelefono"],
    },
    ordineOperazione: {
        descrStrumFinanziario: ["nomeCompletoODesc","codiceIdentificativo","tipoCodiceCFI","codiceSedeNegoziazione","fuoriSede"],
        dataOraOrdine : ["dataInizio","dataFine","fusoOrario"],
    },
    descrizioneNaturaSospetto: {
        naturaSospetto : ["naturaSospetto"],
        motiviSospetto : ["motiviSospetto"],
    },
    identitaDelSospettato: {
        informazioniPersonali : ["nome","cognome","relazioneConEmittenteStrumFinanziari"]
    },
    informazioniSupplementariGenerali: {
        informazioniSupplementari : ["iniziativeControSoggettoSegnalato"]
    }
}

export default StorRequiredFields
